import {
  WHATSAPP_URL,
  INSTAGRAM_URL,
  PINTEREST_URL,
  TIKTOK_URL,
} from '../constants';
import { gsap, SplitText, useMotion } from '../lib/motion';

const socials = [
  { label: "Instagram", href: INSTAGRAM_URL, testid: "footer-instagram-link" },
  { label: "TikTok", href: TIKTOK_URL, testid: "footer-tiktok-link" },
  { label: "Pinterest", href: PINTEREST_URL, testid: "footer-pinterest-link" },
  { label: "WhatsApp", href: WHATSAPP_URL, testid: "footer-phone" },
];

export default function Footer() {
  const scope = useMotion((root) => {
    // Assinatura final: letras do nome sobem uma a uma.
    const wordmark = root.querySelector('[data-wordmark]');
    SplitText.create(wordmark, {
      type: 'chars',
      mask: 'chars',
      charsClass: 'split-char',
      onSplit: (self) =>
        gsap.from(self.chars, {
          yPercent: 115,
          duration: 1.2,
          ease: 'expo.out',
          stagger: 0.035,
          scrollTrigger: { trigger: wordmark, start: 'clamp(top 95%)', toggleActions: 'play none none none' },
        }),
    });
  });

  return (
    <footer ref={scope} className="border-t border-rule" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-16 pb-28 md:pb-12">
        <p data-wordmark aria-label="nyjuliabraids" className="text-[clamp(3rem,12vw,9rem)] font-extrabold tracking-tighter leading-none text-ink mb-10">
          nyjuliabraids
        </p>
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
          <ul data-rise="0.3" className="flex flex-wrap gap-x-6 gap-y-2">
            {socials.map((s) => (
              <li key={s.label}>
                <a
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-semibold text-ink hover:text-tan transition-colors"
                  data-testid={s.testid}
                >
                  {s.label}
                </a>
              </li>
            ))}
          </ul>
          <p className="text-sm text-soft">
            © {new Date().getFullYear()} Nyjuliabraids. Salão de tranças em Campinas, SP.
          </p>
        </div>
      </div>
    </footer>
  );
}
